import { Avatar, ListItemAvatar, SvgIcon } from '@rossum/ui/material';

export const ActionIcon = ({
  icon: Icon,
  disabled,
  withCustomPadding,
}: {
  disabled?: boolean;
  icon: typeof SvgIcon;
  withCustomPadding?: boolean;
}) => (
  <ListItemAvatar sx={withCustomPadding ? { minWidth: 40, pr: 1 } : {}}>
    <Avatar
      sx={{
        backgroundColor: t => t.palette.action.disabledBackground,
      }}
    >
      <Icon
        fontSize="small"
        sx={{
          color: t =>
            disabled
              ? t.palette.action.disabled
              : t.palette.getContrastText(t.palette.action.disabledBackground),
        }}
      />
    </Avatar>
  </ListItemAvatar>
);
